"use strict";
const _ = require('lodash');
const order = require('../order');
const orderFullfillmentCenter = require('../orderFullfillmentCenter');
class Invariantor {
    constructor(entity) {
        this.entity = entity;
        this.entity.settings = entity.settings || {};
        this.entity.incomings = entity.incomings || [];
        this.entity.getEndpoints = entity.getEndpoints || [];
        this.entity.outgoings = entity.outgoings || [];
        this.entity.scheduledRuns = entity.scheduledRuns || [];
    }
    ensureS3StorageFolder() {
        this.entity.s3StorageFolder = (this.entity.s3StorageFolder ||
            this.entity.name ||
            '').replace(/\s+/g, '-');
        return this;
    }
    ensureIncomingEndpoint() {
        this.entity.incomingEndpoint = _.toLower(this.entity.incomingEndpoint);
        return this;
    }
    ensureShouldMapCustomerDeliveryEmail() {
        this.entity.settings.SHOULD_MAP_CUSTOMER_DELIVERY_EMAIL = _.get(this.entity, 'settings.SHOULD_MAP_CUSTOMER_DELIVERY_EMAIL', true);
        return this;
    }
    ensureCsvDelimiter() {
        this.entity.settings.CSV_DELIMITER = _.get(this.entity, 'settings.CSV_DELIMITER', ',');
        return this;
    }
    ensureCsvNewLineCharacter() {
        this.entity.settings.CSV_NEWLINE = _.get(this.entity, 'settings.CSV_NEWLINE', '\n');
        return this;
    }
    ensureCsvQuote() {
        this.entity.settings.CSV_QUOTE = _.get(this.entity, 'settings.CSV_QUOTE', '"');
        return this;
    }
    ensureCsvColumnToSplitBy() {
        this.entity.settings.CSV_COLUMN_TO_SPLIT_BY = _.get(this.entity, 'settings.CSV_COLUMN_TO_SPLIT_BY', '');
        return this;
    }
    ensureCsvHeaders() {
        this.entity.settings.CSV_HEADERS = _.get(this.entity, 'settings.CSV_HEADERS', []);
        return this;
    }
    ensureCsvSkipLines() {
        this.entity.settings.CSV_SKIP_LINES = _.get(this.entity, 'settings.CSV_SKIP_LINES', 0);
        return this;
    }
    ensureHttpIncomings() {
        this.entity.incomings = this.entity.incomings.map(incoming => {
            if (incoming.incomingChannel === 'HTTP-POST') {
                return { ...incoming, filter: _.toLower(incoming.filter) };
            }
            return incoming;
        });
        return this;
    }
    ensureGetEndpoints() {
        this.entity.getEndpoints = this.entity.getEndpoints.map(getEndpoint => ({
            ...getEndpoint,
            name: _.toLower(getEndpoint.name),
        }));
        return this;
    }
    ensureOrganizationId() {
        if (this.entity.organizationId) {
            this.entity.settings = {
                ...this.entity.settings,
                ORGANIZATION_ID: this.entity.organizationId,
            };
        }
        return this;
    }
    ensureEdifactOutgoings() {
        this.entity.outgoings = this.entity.outgoings.map(outgoing => {
            if (outgoing.writer === 'EDIFACTD96AORDERS' ||
                outgoing.writer === 'PEPPOLBISORDERING32') {
                return { ...outgoing, outputTemplate: '' };
            }
            return outgoing;
        });
        return this;
    }
    ensureOmitPriceOnOrderRow() {
        this.entity.settings.OMIT_PRICE_ON_ORDERROW = _.get(this.entity, 'settings.OMIT_PRICE_ON_ORDERROW', false);
        return this;
    }
    ensureFortnoxInvariants() {
        if (!this.entity.type || this.entity.type !== 'FORTNOX') {
            return this;
        }
        this.entity.incomings = this.entity.incomings.map(incoming => {
            switch (incoming.name) {
                case 'Kunder':
                    return {
                        ...incoming,
                        name: 'Kunder',
                        entityName: 'supplierCustomer',
                        filter: '-',
                        reader: 'FORTNOXCUSTOMER',
                        incomingChannel: 'CRONJOB',
                    };
                case 'Artiklar':
                    return {
                        ...incoming,
                        name: 'Artiklar',
                        entityName: 'article',
                        filter: '-',
                        reader: 'FORTNOXARTICLE',
                        incomingChannel: 'CRONJOB',
                    };
                case 'Leverantörer':
                    return {
                        ...incoming,
                        name: 'Leverantörer',
                        entityName: 'supplier',
                        filter: '-',
                        reader: 'FORTNOXSUPPLIER',
                        incomingChannel: 'CRONJOB',
                    };
                case 'Mottar en order':
                    return {
                        ...incoming,
                        name: 'Mottar en order',
                        entityName: 'order',
                        filter: '-',
                        reader: 'FORTNOXORDER',
                        incomingChannel: 'CRONJOB',
                    };
                case 'Prislistor':
                    return {
                        ...incoming,
                        name: 'Prislistor',
                        entityName: 'priceList',
                        filter: '-',
                        reader: 'NOOP',
                        incomingChannel: 'CRONJOB',
                    };
                case 'Lagerställen med lagersaldo':
                    return {
                        ...incoming,
                        name: 'Lagerställen',
                        entityName: 'orderFullfillmentCenter',
                        filter: '-',
                        reader: 'NOOP',
                        incomingChannel: 'CRONJOB',
                    };
                case 'Lagerställen':
                    return {
                        ...incoming,
                        name: 'Lagerställen',
                        entityName: 'orderFullfillmentCenter',
                        filter: '-',
                        reader: 'NOOP',
                        incomingChannel: 'CRONJOB',
                    };
                case 'Lagersaldo':
                    return {
                        ...incoming,
                        name: 'Lagersaldo',
                        entityName: 'article',
                        filter: 'articleBatch',
                        reader: 'NOOP',
                        incomingChannel: 'CRONJOB',
                    };
                default:
                    // If the incoming is not one of the predefined Fortnox incomings, we leave it as is.
                    return incoming;
            }
        });
        this.entity.settings = {
            ...this.entity.settings,
            USES_FORTNOX_WAREHOUSE_MODULE: _.get(this.entity, 'settings.USES_FORTNOX_WAREHOUSE_MODULE', false),
            PRICE_LISTS_SHOULD_PUBLISH_ARTICLES: _.get(this.entity, 'settings.PRICE_LISTS_SHOULD_PUBLISH_ARTICLES', false),
            FORTNOX_RECYCLE_ARTICLE_NUMBERS: _.get(this.entity, 'settings.FORTNOX_RECYCLE_ARTICLE_NUMBERS', []),
            BLOCKED_OFC_CODES: _.get(this.entity, 'settings.BLOCKED_OFC_CODES', []),
        };
        return this;
    }
    /**
     * Generic helper to ensure required items exist in an entity array property
     * @param {string} propertyName - The name of the entity property (e.g., 'incomings', 'outgoings')
     * @param {Array} requiredItems - Array of required items to ensure
     * @param {Function} matchFn - Function to determine if an existing item matches a required item
     */
    ensureRequiredItems(propertyName, requiredItems, matchFn) {
        // Ensure the property exists as an array
        this.entity[propertyName] = this.entity[propertyName] || [];
        // Update existing items with required properties
        this.entity[propertyName] = this.entity[propertyName].map(existingItem => {
            const requiredItem = requiredItems.find(req => matchFn(req, existingItem));
            return requiredItem ? { ...existingItem, ...requiredItem } : existingItem;
        });
        // Add missing required items
        requiredItems.forEach(requiredItem => {
            const exists = this.entity[propertyName].find(existingItem => matchFn(requiredItem, existingItem));
            if (!exists) {
                this.entity[propertyName].push(requiredItem);
            }
        });
    }
    ensureExtendInvariants() {
        if (!this.entity.type || this.entity.type !== 'EXTEND') {
            return this;
        }
        const requiredIncomings = [
            {
                active: true,
                filter: 'webhooks',
                name: 'Ta emot webhook',
                reader: 'EXTENDWEBHOOK',
                incomingChannel: 'HTTP-POST',
                target: { metadata: { name: 'webhooks' } },
                metadata: { name: 'webhooks' },
            },
            {
                active: true,
                filter: 'orders',
                name: 'Ta emot ordrar',
                reader: 'EXTENDORDER',
                entityName: 'order',
                incomingChannel: 'INTERNALCALL',
                metadata: { name: 'orders' },
                target: { metadata: { name: 'orders' } },
            },
            {
                active: true,
                filter: 'purchaseOrders',
                name: 'Ta emot inleverans uppdateringar',
                reader: 'EXTENDPURCHASEORDER',
                entityName: 'purchaseOrder',
                incomingChannel: 'INTERNALCALL',
                metadata: { name: 'purchaseOrders' },
                target: { metadata: { name: 'purchaseOrders' } },
            },
            {
                active: true,
                filter: 'returnOrders',
                name: 'Ta emot retur ordrar',
                reader: 'EXTENDRETURNORDER',
                entityName: 'order',
                incomingChannel: 'INTERNALCALL',
                metadata: { name: 'returnOrders' },
                target: { metadata: { name: 'returnOrders' } },
            },
            {
                active: true,
                filter: 'stockQuantity',
                name: 'Ta emot lagersaldo uppdateringar',
                reader: 'EXTENDSTOCKQUANTITY',
                entityName: 'article',
                incomingChannel: 'INTERNALCALL',
                metadata: { name: 'stockQuantity' },
                target: { metadata: { name: 'stockQuantity' } },
            },
            {
                active: true,
                filter: 'customers',
                name: 'Ta emot kunder',
                entityName: 'customerSubUnit',
                reader: 'EXTENDCUSTOMER',
                incomingChannel: 'INTERNALCALL',
                metadata: { name: 'customers' },
                target: { metadata: { name: 'customers' } },
            },
            {
                active: true,
                filter: 'invoices',
                name: 'Ta emot fakturor',
                reader: 'EXTENDINVOICE',
                entityName: 'invoice',
                incomingChannel: 'INTERNALCALL',
                metadata: { name: 'invoices' },
                target: { metadata: { name: 'invoices' } },
            },
        ];
        const requiredOutgoings = [
            {
                active: true,
                name: 'Skicka nya artiklar',
                triggeredByEvent: 'PURCHASE_ORDER_REQUESTED',
                filter: `payload.fullEntity.orderFullfillmentCenterId === '${orderFullfillmentCenter.EXACTA_ORDER_FULLFILLMENT_CENTER_ID}'`,
                writer: 'EXTENDARTICLEFROMPURCHASEORDER',
                entityName: 'article',
                outgoingChannel: 'v1.extend.createArticle',
                metadata: { name: 'createArticle' },
                target: { metadata: { name: 'createArticle' } },
            },
            {
                active: true,
                name: 'Skicka nya kunder',
                triggeredByEvent: 'ORDER_PLACED',
                filter: `payload.fullEntity.orderOrigin !== '${order.orderOrigins.systembolaget}' && payload.fullEntity.orderFullfillmentCenterId === ORGANIZATION_EXACTA_ORDER_FULLFILLMENT_CENTER_ID`,
                writer: 'EXTENDCUSTOMERFROMORDER',
                entityName: 'customerSubUnit',
                outgoingChannel: 'v1.extend.sendCustomer',
                metadata: { name: 'sendCustomer' },
                target: { metadata: { name: 'sendCustomer' } },
            },
            {
                active: true,
                name: 'Uppdatera artiklar',
                triggeredByEvent: 'ARTICLE_UPDATED',
                filter: `payload.fullEntity.metadata?.extendId`,
                entityName: 'article',
                writer: 'EXTENDARTICLE',
                outgoingChannel: 'v1.extend.updateArticle',
                metadata: { name: 'updateArticle' },
                target: { metadata: { name: 'updateArticle' } },
            },
            {
                active: true,
                name: 'Uppdatera kunder',
                triggeredByEvent: 'CUSTOMER_SUB_UNIT_UPDATED',
                filter: `!!payload.fullEntity`,
                entityName: 'customerSubUnit',
                writer: 'EXTENDCUSTOMER',
                outgoingChannel: 'v1.extend.updateCustomer',
                metadata: { name: 'updateCustomer' },
                target: { metadata: { name: 'updateCustomer' } },
            },
            {
                active: true,
                name: 'Skicka order',
                triggeredByEvent: 'ORDER_APPROVED',
                filter: `!payload.fullEntity.metadata?.extendId && payload.fullEntity.orderOrigin !== '${order.orderOrigins.systembolaget}' && payload.fullEntity.customerSubUnit.metadata?.extendId && payload.fullEntity.orderFullfillmentCenterId === ORGANIZATION_EXACTA_ORDER_FULLFILLMENT_CENTER_ID`,
                entityName: 'order',
                writer: 'EXTENDORDER',
                outgoingChannel: 'v1.extend.sendOrder',
                metadata: { name: 'sendOrder' },
                target: { metadata: { name: 'sendOrder' } },
            },
            {
                active: true,
                name: 'Skicka inleveranser',
                triggeredByEvent: 'PURCHASE_ORDER_SENT_TO_SUPPLIER',
                filter: `!payload.fullEntity.metadata?.extendId && payload.fullEntity.orderFullfillmentCenterId === '${orderFullfillmentCenter.EXACTA_ORDER_FULLFILLMENT_CENTER_ID}'`,
                entityName: 'purchaseOrder',
                writer: 'EXTENDPURCHASEORDER',
                outgoingChannel: 'v1.extend.sendPurchaseOrder',
                metadata: { name: 'sendPurchaseOrder' },
                target: { metadata: { name: 'sendPurchaseOrder' } },
            },
        ];
        const requiredScheduledRuns = [
            {
                name: 'retur order',
                active: true,
                schedule: '25 11,21 * * *',
                jobName: 'extend-import-return-orders',
                metadata: { name: 'returnOrders' },
                target: { metadata: { name: 'returnOrders' } },
            },
            {
                name: 'order',
                active: false,
                schedule: '2 3 * * *',
                jobName: 'extend-import-customer-orders',
                metadata: { name: 'customerOrders' },
                target: { metadata: { name: 'customerOrders' } },
            },
            {
                name: 'fakturor',
                active: false,
                schedule: '2 4 * * *',
                jobName: 'extend-import-customer-invoices',
                metadata: { name: 'customerInvoices' },
                target: { metadata: { name: 'customerInvoices' } },
            },
        ];
        const matcher = (req, existing) => req.name === existing.name;
        // Ensure all required items using the generic helper
        this.ensureRequiredItems('incomings', requiredIncomings, matcher);
        this.ensureRequiredItems('outgoings', requiredOutgoings, matcher);
        this.ensureRequiredItems('scheduledRuns', requiredScheduledRuns, matcher);
        return this;
    }
    value() {
        return this.entity;
    }
}
module.exports = entity => {
    const ensured = new Invariantor(entity)
        .ensureEdifactOutgoings()
        .ensureOrganizationId()
        .ensureIncomingEndpoint()
        .ensureHttpIncomings()
        .ensureGetEndpoints()
        .ensureOmitPriceOnOrderRow()
        .ensureCsvDelimiter()
        .ensureCsvNewLineCharacter()
        .ensureCsvQuote()
        .ensureCsvSkipLines()
        .ensureCsvColumnToSplitBy()
        .ensureCsvHeaders()
        .ensureS3StorageFolder()
        .ensureShouldMapCustomerDeliveryEmail()
        .ensureFortnoxInvariants()
        .ensureExtendInvariants()
        .value();
    return ensured;
};
